import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes,Route,BrowserRouter } from 'react-router-dom';
import App from './App';
import Test from './Test';
const element = document.getElementById("root")
const root = ReactDOM.createRoot(element)

root.render(
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<App/>}/>
            <Route path="/test" element={<Test/>}/>
        </Routes>
</BrowserRouter>

)
